<template>
  <article class="explorations ">
    <main class="padded">
      <h1>Explorations</h1>
      <p>
        I like learning and trying things - ending up with being the 'jack of
        all trades, master of none' (well, hopefully master of some).
      </p>
      <p>
        After years of anxiety over choosing 'one thing' to master, I have
        finally decided to embrace my curiosity and greediness . For now, I plan
        to indulge in the different experiments and hope they lead to figuring
        out my own style and passion on the way.
      </p>
      <p>
        My experiments mostly lie around art, design, code and writing, and the
        intersections of these.
      </p>
    </main>
  </article>
</template>

<script>
export default {}
</script>

<style scoped>
.explorations {
  height: 100%;
  background: repeating-linear-gradient(
      var(--grey-light) 0rem 0.1rem,
      transparent 0.2rem 0.8rem
    ),
    repeating-linear-gradient(
      to right,
      var(--grey-light) 0rem 0.1rem,
      var(--bg-color) 0.12rem 0.8rem
    );
}
</style>
